'use client';
import React from 'react';
import Breadcrumb, { BreadcrumbItem } from './Breadcrumb';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title?: string;
  icon?: React.ReactNode;
  breadcrumbs: BreadcrumbItem[];
  children?: React.ReactNode;
  className?: string;
  h1?: string;
  h2?: string;
  underH2?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  icon,
  breadcrumbs,
  children,
  className,
  h1,
  h2,
  underH2,
}) => {
  return (
    <header className={`${styles.headerWrapper}${className ? ` ${className}` : ''}`}>
      <div className={styles.container}>
        <Breadcrumb items={breadcrumbs} h1={h1} h2={h2} underH2={underH2} />

        <div className={styles.titleRow}>
          {(title || icon) && (
            <h1 className={styles.title}>
              {icon}
              {title}
            </h1>
          )}

          {children && (
            <div className={styles.childrenWrapper}>
              {children}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default PageHeader;